import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import React from 'react';
import { useTranslation } from 'react-i18next';

function DocsSelect(): JSX.Element {
  const { t } = useTranslation();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (): void => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (url: string): void => {
    window.open(url, '_blank');
    handleClose();
  };

  return (
    <Box>
      <Tooltip arrow title={t('select.help.tooltip')} placement="bottom">
        <Box onClick={handleClick} sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
          <HelpOutlineIcon sx={{ color: '#fff' }} />
        </Box>
      </Tooltip>
      <Menu
        id="docs-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'docs-button',
          role: 'menu',
        }}
      >
        <Tooltip arrow title={t('select.help.in_preparation')} placement="right">
          <div>
            <MenuItem disabled sx={{ color: 'text.disabled' }}>
              {t('select.help.manual')}
            </MenuItem>
          </div>
        </Tooltip>
        <MenuItem onClick={() => handleMenuItemClick('/docs/codecs/')}>{t('select.help.codecs')}</MenuItem>
        <Tooltip arrow title={t('select.help.in_preparation')} placement="right">
          <div>
            <MenuItem disabled sx={{ color: 'text.disabled' }}>
              {t('select.help.open_api')}
            </MenuItem>
          </div>
        </Tooltip>
      </Menu>
    </Box>
  );
}

export default DocsSelect;
